import React, { Fragment, useEffect, useState } from "react";

import { DateRange } from "react-date-range";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import { Popper, styled, makeStyles } from "@material-ui/core";

import CustomButton from "./CustomButton";
import PopperButton from "./PopperButton";
import { CalendarToday } from "@material-ui/icons";
import { dayMonthDate } from "../../helper/index";

const StyledDiv = styled("div")({
  ".rdrDayToday .rdrDayNumber span:after": {
    backgroundColor: "rgba(226, 19, 110, 1)",
  },
  ".rdrCalendarWrapper": {
    borderRadius: "12px",
  },
});

const useStyles = makeStyles((theme) => ({
  popperWrapper: {
    background: "white",
    boxShadow: "0px 16px 24px rgba(54, 43, 115, 0.16)",
    borderRadius: 16,
  },
  paragraph: {
    color: "#362B73",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "16px",
    margin: 0,
  },
  paragraphHead: {
    margin: 0,
    fontSize: 12,
    fontWeight: 400,
    opacity: 0.4,
  },
  content: {
    marginLeft: theme.spacing(2),
    textAlign: "left",
  },
  buttonContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default function DateRangeSelect({ endDate, startDate, onChange }) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [state, setState] = React.useState([
    {
      startDate: startDate ? new Date(startDate) : new Date(endDate),
      endDate: new Date(endDate),
      key: "selection",
    },
  ]);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDone = () => {
    const [{ startDate, endDate }] = state;
    onChange(startDate, endDate);
    handleClose();
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    setState([
      {
        startDate: startDate ? new Date(startDate) : new Date(endDate),
        endDate: new Date(endDate),
        key: "selection",
      },
    ]);
  }, [startDate, endDate]);

  return (
    <Fragment>
      <Popper
        style={{ zIndex: 1 }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <div className={classes.popperWrapper}>
          <StyledDiv>
            <DateRange
              rangeColors={["rgba(226, 19, 110, 1)", "rgba(54, 43, 115, 1)"]}
              onChange={(item) => setState([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={state}
            />
          </StyledDiv>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              paddingBottom: 16,
            }}
          >
            <CustomButton
              onClick={handleClose}
              text={"Cancel"}
              type={"cancel"}
              width={"40%"}
            />
            <CustomButton
              onClick={handleDone}
              text={"Apply"}
              type={"ok"}
              width={"40%"}
            />
          </div>
        </div>
      </Popper>

      <PopperButton width={250} onClick={handleClick} gutter={[1, 0, 0]}>
        <div className={classes.buttonContent}>
          <CalendarToday style={{ color: "rgba(54, 43, 115, 0.4)" }} />
          <div className={classes.content}>
            <p className={classes.paragraphHead}>Date Range</p>
            <p className={classes.paragraph}>
              {dayMonthDate(startDate)} - {dayMonthDate(endDate)}
            </p>
          </div>
        </div>
      </PopperButton>
    </Fragment>
  );
}
